import PropTypes from "prop-types";
import { Component } from "react";
import Message from "components/message";
import SessionUser from "utils/user-storage";
import intl from "react-intl-universal";
import TextArea from "components/textarea";

import {
  aceitarRenegociacaoPedidoAtenderDemanda,
  recusarRenegociacaoPedidoAtenderDemanda,
} from "./renegociacao-pedido-atender-demanda.service";

import RenegociacaoPedidoAtenderDemandaStyled from "./renegociacao-pedido-atender-demanda.styled";
import { formatErrorMessage } from "utils/handle-error";
import Button from "components/button";

class RenegociacaoPedidoAtenderDemanda extends Component {
  static propTypes = {
    refreshTimeLine: PropTypes.func, // func ao invés de any
    idNegotiation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    dataColeta: PropTypes.string.isRequired,
    dataEntrega: PropTypes.string.isRequired,
    horaEntrega: PropTypes.string.isRequired,

    idDestino: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idMaterial: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idOrigem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idPedido: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,

    observacao: PropTypes.string.isRequired,
    quantidade: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    justification: PropTypes.any,
  };

  static defaultProps = {
    refreshTimeLine: () => {},
    justification: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      showMsg: false,
      textMsg: "",
      titleMsg: "",
      observacao: "",
      isReload: true,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.setState({ observacao: "" });
  }

  changeValue = (event) => {
    const prop = event.target.name;
    const value = event.target.value;

    this.setState({
      [prop]: value,
    });
  };

  aceitarRenegociacaoPedidoAtenderDemanda = async () => {
    try {
      const model = {
        IdPedido: this.props.idPedido,
        IdOrigem: this.props.idOrigem,
        IdDestino: this.props.idDestino,
        IdMaterial: this.props.idMaterial,
        DataColeta: this.props.dataColeta,
        DataEntrega: this.props.dataEntrega,
        HoraEntrega: this.props.horaEntrega,
        Quantidade: this.props.quantidade,
        Observacao: this.state.observacao ? this.state.observacao : this.props.observacao,
        IdUsuario: SessionUser.get().Id,
        idNegotiation: this.props.idNegotiation,
        TypeJustificationManualSuggestion: this.props.justification,
      };

      this.setState({ isLoading: true });
      await aceitarRenegociacaoPedidoAtenderDemanda(model);
      this.setState({ isLoading: false });

      this.showMessageAceiteRenegociacao();
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.props.refreshTimeLine?.();
    }
  };

  recusarRenegociacaoPedidoAtenderDemanda = async () => {
    try {
      const model = {
        IdPedido: this.props.idPedido,
        IdUsuario: SessionUser.get().Id,
        DataColeta: this.props.dataColeta,
        DataEntrega: this.props.dataEntrega,
        HoraEntrega: this.props.horaEntrega,
        Observacao: this.state.observacao,
        Quantidade: this.props.quantidade,
      };

      this.setState({ isLoading: true });
      await recusarRenegociacaoPedidoAtenderDemanda(model);
      this.setState({ isLoading: false });

      this.showMessageRecusaRenegociacao();
    } catch (error) {
      this.proccessError(error);
    }
  };

  showMessageAceiteRenegociacao = () => {
    this.setState({
      showMsg: true,
      titleMsg: intl.get("stocks.timeline.feedback.renegotiationOrder"),
      textMsg: intl.get("stocks.timeline.feedback.renegotiationAccept"),
      isReload: true,
    });
  };

  showMessageRecusaRenegociacao() {
    this.setState({
      showMsg: true,
      titleMsg: intl.get("stocks.timeline.feedback.renegotiationOrder"),
      textMsg: intl.get("stocks.timeline.feedback.renegotiationRefuse"),
      isReload: true,
    });
  }

  proccessError = (exception) => {
    this.setState({
      showMsg: true,
      titleMsg: intl.get("stocks.timeline.feedback.errorFound"),
      textMsg:
        exception.response != null && exception.response.status === 400
          ? formatErrorMessage(exception)
          : intl.get("stocks.timeline.feedback.serverError"),
      isReload: false,
    });
  };

  handleClose = () => {
    this.setState({ showMsg: false });

    if (this.state.isReload) {
      window.location.reload();
    }
  };

  render() {
    const { observacao } = this.state;

    return (
      <RenegociacaoPedidoAtenderDemandaStyled>
        <div className="renegociacao-pedido-line-textarea">
          <TextArea
            required
            name="observacao"
            label={intl.get("stocks.commons.observation")}
            value={observacao || ""}
            onChange={this.changeValue}
            className="txtarea-observacao"
          />
        </div>
        <div className="renegociacao-pedido-line-buttons">
          <Button
            disabled={this.state.isLoading}
            value={intl.get("stocks.timeline.refuse")}
            onClick={this.recusarRenegociacaoPedidoAtenderDemanda}
            buttonType="danger"
            className="button btn-recusar"
          />
          <Button
            disabled={this.state.isLoading}
            value={intl.get("stocks.timeline.accept")}
            onClick={this.aceitarRenegociacaoPedidoAtenderDemanda}
            buttonType="primary"
            className="button btn-aceitar"
          />
        </div>
        <Message
          show={this.state.showMsg}
          text={this.state.textMsg}
          title={this.state.titleMsg}
          handleClose={this.handleClose}
        />
      </RenegociacaoPedidoAtenderDemandaStyled>
    );
  }
}

export default RenegociacaoPedidoAtenderDemanda;